(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dIgAg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fbc3faa75249e31$export$2e2bcd8739ae039; });
/**
 * Embed Popup Component
 * Handles popup/modal functionality for embed forms (iframes, scripts, etc.)
 * Used across multiple blocks (FAQ, Image with text and button, etc.)
 *
 * Takes the target document explicitly so the exact same implementation can
 * be instantiated against the frontend page document and, separately,
 * against the block-editor canvas iframe's own document (see
 * src/js/_editor.js) — a plain top-window `document` reference would never
 * see clicks happening inside that iframe's own DOM tree.
 */ 
var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");
var $9fbc3faa75249e31$var$EmbedPopup = /*#__PURE__*/ function() {
    "use strict";
    function EmbedPopup() {
        var doc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
        (0, $bB0zn._)(this, EmbedPopup);
        this.doc = doc;
        this.activePopup = null;
        this.init();
    }
    (0, $6QEWP._)(EmbedPopup, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                // Wait for DOM to be ready
                if (this.doc.readyState === 'loading') this.doc.addEventListener('DOMContentLoaded', function() {
                    return _this.bindEvents();
                });
                else this.bindEvents();
            }
        },
        {
            key: "bindEvents",
            value: function bindEvents() {
                // Handle popup triggers
                this.bindTriggers();
                // Handle popup closers
                this.bindClosers();
                // Handle ESC key
                this.bindEscapeKey();
            }
        },
        {
            key: "bindTriggers",
            value: function bindTriggers() {
                var _this = this;
                // Delegated (like bindClosers below) rather than a listener per trigger
                // found at bind time: the editor canvas can render new triggers later
                // (ACF updates a block's preview in place on field changes), and a
                // one-time querySelectorAll snapshot would never see them.
                this.doc.addEventListener('click', function(e) {
                    var trigger = e.target.closest('[data-popup-trigger]');
                    if (!trigger) return;
                    e.preventDefault();
                    var popupId = trigger.getAttribute('data-popup-trigger');
                    _this.openPopup(popupId);
                });
            }
        },
        {
            key: "bindClosers",
            value: function bindClosers() {
                var _this = this;
                // Use event delegation for close buttons and overlays
                this.doc.addEventListener('click', function(e) {
                    // Check if clicked element is a close button or overlay (support both new and legacy classes)
                    var isCloseButton = e.target.classList.contains('embed-popup__close') || e.target.classList.contains('faq-popup__close');
                    var isOverlay = e.target.classList.contains('embed-popup__overlay') || e.target.classList.contains('faq-popup__overlay');
                    if (isCloseButton || isOverlay) {
                        var popup = e.target.closest('.embed-popup') || e.target.closest('.faq-popup');
                        if (popup) _this.closePopup(popup);
                    }
                });
            }
        },
        {
            key: "bindEscapeKey",
            value: function bindEscapeKey() {
                var _this = this;
                this.doc.addEventListener('keydown', function(e) {
                    if (e.key === 'Escape' && _this.activePopup) _this.closePopup(_this.activePopup);
                });
            }
        },
        {
            key: "openPopup",
            value: function openPopup(popupId) {
                var popup = this.doc.getElementById(popupId);
                if (!popup) {
                    console.warn('Popup with id "'.concat(popupId, '" not found'));
                    return;
                }
                // Close any currently active popup
                if (this.activePopup && this.activePopup !== popup) this.closePopup(this.activePopup);
                // Remove inline hide used to prevent FOUC while CSS is deferred
                popup.style.removeProperty('display');
                // Add visible class - check if it's legacy FAQ popup or new embed popup
                var visibleClass = popup.classList.contains('faq-popup') ? 'faq-popup--visible' : 'embed-popup--visible';
                popup.classList.add(visibleClass);
                popup.setAttribute('aria-hidden', 'false');
                // Add body class - support both new and legacy
                this.doc.body.classList.add('embed-popup-open', 'popup-open');
                this.activePopup = popup;
                // Focus management for accessibility
                this.setFocusTrap(popup);
            }
        },
        {
            key: "closePopup",
            value: function closePopup(popup) {
                if (!popup) return;
                // Remove both new and legacy visible classes
                popup.classList.remove('embed-popup--visible', 'faq-popup--visible');
                popup.setAttribute('aria-hidden', 'true');
                this.doc.body.classList.remove('embed-popup-open', 'popup-open');
                if (this.activePopup === popup) this.activePopup = null;
            }
        },
        {
            key: "setFocusTrap",
            value: function setFocusTrap(popup) {
                // Get all focusable elements within the popup
                var focusableElements = popup.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                if (focusableElements.length > 0) // Focus the first focusable element (usually the close button)
                focusableElements[0].focus();
            }
        }
    ]);
    return EmbedPopup;
}();
// Initialize popup system against the page's own document when this script
// loads normally (frontend, or a plain non-iframed admin load) — this is
// the exact, unchanged frontend contract. The editor also imports the
// `EmbedPopup` class directly (see src/js/_editor.js) to instantiate a
// second instance scoped to the canvas iframe's own document.
var $9fbc3faa75249e31$var$embedPopupInstance = new $9fbc3faa75249e31$var$EmbedPopup(document);
// Export for potential external use
if (typeof window !== 'undefined') window.EmbedPopup = $9fbc3faa75249e31$var$embedPopupInstance;
var $9fbc3faa75249e31$export$2e2bcd8739ae039 = $9fbc3faa75249e31$var$EmbedPopup;

});
parcelRegister("bB0zn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8713978b2328d32b$export$71511d61b312f219; });
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("6QEWP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4fc75ccb937ab1df$export$71511d61b312f219; });
function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});



parcelRequire("dIgAg");
})();
//# sourceMappingURL=embed-popup.js.map
